import { repositoryMdm } from "../../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../../_base/extension/NotificationExtension";
import { getNameProvince } from "../../../../DeliveryConfig/DeliveryPartner/helper";
import {
  ShippingPartner,
  SpecificationsCheckResult,
  WarehouseInfo,
} from "../types/modalDeliveryTypes";
import {
  COD_LIMITS,
  SHIPPING_LIMITATIONS,
  WAREHOUSE_DATA,
} from "../constants/modalDeliveryConstants";
import { getProvinceSelectNew } from "../../../../../service/getSelectApi";

export const handleCopyAddress = async (
  customerAddress: string,
  customerProvinceId: string,
  customerCommuneId: string
) => {
  try {
    // const provinceName = await getNameProvince(customerProvinceId);
    const getData = await getProvinceSelectNew();
    const provinceName = getData.find(
      (item: any) => Number(item.id) === Number(customerProvinceId)
    )?.name;


    const communeResponse = await repositoryMdm.get(
      `/api/v1/TblDmCommuneMoi/get-select?ProvinceIds=${customerProvinceId}`
    );
    const communeData = communeResponse?.data ?? [];
    const communeName =
      communeData.find((item: any) => item.value === customerCommuneId)?.text ||
      "";

    // const fullAddress = `${customerAddress}, ${communeName}, ${provinceName}`;
    const addressParts = [customerAddress, communeName, provinceName].filter(
      Boolean
    );
    const fullAddress = addressParts.join(", ");

    await navigator.clipboard.writeText(fullAddress);
    NotificationExtension.Success("Đã copy địa chỉ vào clipboard!");
  } catch (error) {
    console.error("Error copying address:", error);
    NotificationExtension.Fails("Không thể copy địa chỉ");
  }
};

export const handleCopyCustomerInfo = async (
  customerName: string,
  telephoneNumber: string
) => {
  try {
    if (!customerName && !telephoneNumber) {
      NotificationExtension.Warn("Chưa có thông tin người nhận!");
      return;
    }

    const customerInfo = `${customerName} - ${telephoneNumber}`;
    await navigator.clipboard.writeText(customerInfo);
    NotificationExtension.Success("Đã copy thông tin người nhận!");
  } catch (error) {
    console.error("Error copying customer info:", error);
    NotificationExtension.Fails("Không thể copy thông tin người nhận");
  }
};

export const getPartnerCodLimit = (partner: ShippingPartner): number | null => {
  if (partner.name === "Giao hàng tiết kiệm") return COD_LIMITS.GHTK;
  if (partner.name === "Ahamove" && partner.description === "Siêu tốc")
    return COD_LIMITS.AHAMOVE_SIEU_TOC;
  if (
    partner.name === "Ahamove" &&
    partner.description === "Siêu tốc tiết kiệm"
  )
    return COD_LIMITS.AHAMOVE_TIET_KIEM;
  return null;
};

export const getPartnerLimitations = (partner: ShippingPartner) => {
  if (partner.name === "Giao hàng tiết kiệm") {
    return {
      maxWeight: 20,
      maxDimension: 60,
      hasLimitation: true,
    };
  }

  if (partner.name === "Ahamove") {
    if (partner.description === "Siêu tốc") {
      return { maxWeight: 30, maxDimension: 60, hasLimitation: true };
    } else if (partner.description === "Siêu tốc tiết kiệm") {
      return { maxWeight: 30, maxDimension: 60, hasLimitation: true };
    } else if (partner.description === "Đồng giá 25k") {
      return { maxWeight: 30, maxDimension: 60, hasLimitation: true };
    }
  }

  return { maxWeight: null, maxDimension: null, hasLimitation: false };
};

export const isShippingPartnerDisabled = (
  partner: ShippingPartner,
  specificationsResult: SpecificationsCheckResult | null,
  isHaveVat?: boolean,
  cod?: number,
  payType?: string
): boolean => {
  if (partner.isDisabled || partner.errorMessage) {
    return true;
  }

  if (isHaveVat && cod && cod >= 5000000) {
    if (partner.name === "Giao hàng tiết kiệm" || partner.name === "Ahamove") {
      return true;
    }
  }

  if (!specificationsResult) return false;

  const totalWeight = specificationsResult.totalWeight;
  const maxDimension = specificationsResult.maxDimension;

  if (partner.name === "Giao hàng tiết kiệm") {
    const limits = SHIPPING_LIMITATIONS["GHTK"];
    const orderTotal = cod || 0;
    const isOrderTooLarge =
      payType === "Giao Hàng Thu Tiền(COD)" && orderTotal >= 50000000;

    return (
      totalWeight > limits.maxWeight ||
      maxDimension > limits.maxDimension ||
      isOrderTooLarge
    );
  }

  if (partner.name === "Ahamove") {
    const limits =
      SHIPPING_LIMITATIONS[
        partner.description as keyof typeof SHIPPING_LIMITATIONS
      ];
    if (!limits) return false;

    return totalWeight > limits.maxWeight || maxDimension > limits.maxDimension;
  }

  return false;
};

export const getDisableReason = (
  partner: ShippingPartner,
  specificationsResult: SpecificationsCheckResult | null,
  isHaveVat?: boolean,
  cod?: number,
  payType?: string
): string => {
  if (partner.errorMessage) {
    return partner.errorMessage;
  }

  if (isHaveVat && cod && cod >= 5000000) {
    if (partner.name === "Giao hàng tiết kiệm" || partner.name === "Ahamove") {
      return "Đơn hàng có VAT và COD từ 5 triệu trở lên chỉ được giao bằng đội ngũ nội bộ";
    }
  }

  if (!specificationsResult) return "";

  const totalWeight = specificationsResult.totalWeight;
  const maxDimension = specificationsResult.maxDimension;

  if (partner.name === "Giao hàng tiết kiệm") {
    const limits = SHIPPING_LIMITATIONS["GHTK"];
    const reasons = [];
    const orderTotal = cod || 0;

    if (totalWeight > limits.maxWeight)
      reasons.push(`Trọng lượng vượt quá ${limits.maxWeight}kg`);
    if (maxDimension > limits.maxDimension)
      reasons.push(`Kích thước vượt quá ${limits.maxDimension}cm`);
    if (payType === "Giao Hàng Thu Tiền(COD)" && orderTotal >= 50000000)
      reasons.push(`Giá trị đơn hàng vượt quá 50 triệu đồng`);

    return reasons.join(" và ");
  }

  if (partner.name === "Ahamove") {
    const limits =
      SHIPPING_LIMITATIONS[
        partner.description as keyof typeof SHIPPING_LIMITATIONS
      ];
    if (!limits) return "";

    const reasons = [];

    if (totalWeight > limits.maxWeight)
      reasons.push(`Trọng lượng vượt quá ${limits.maxWeight}kg`);
    if (maxDimension > limits.maxDimension)
      reasons.push(`Kích thước vượt quá ${limits.maxDimension}cm`);

    return reasons.join(" và ");
  }

  return "";
};

export const isCodExceedLimit = (partner: ShippingPartner, cod?: number) => {
  const codLimit = getPartnerCodLimit(partner);
  if (codLimit !== null && typeof cod === "number" && cod > codLimit) {
    return {
      exceeded: true,
      message: `Số tiền thu hộ (COD) vượt quá giới hạn cho đối tác này.\nGiới hạn: ${codLimit.toLocaleString()} đ. Vui lòng chọn đối tác khác hoặc giảm số tiền COD.`,
    };
  }
  return { exceeded: false, message: "" };
};

export const getWarehouseInfo = (branchId: number): WarehouseInfo | null => {
  return WAREHOUSE_DATA.find((warehouse) => warehouse.id === branchId) || null;
};

export const createDataStation = (data: any) => {
  if (!Array.isArray(data)) return [];

  return data.map((item) => ({
    value: String(item.id),
    label: `${item.to_address} - ${item.attribute2}`,
    distance: item?.distance,
  }));
};

export const createDataStationMap = (data: any) => {
  if (!Array.isArray(data)) return [];

  return data.map(({ transportAddress, ...rest }) => ({
    ...rest,
    to_address: transportAddress,
  }));
};
